import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataRowPlaceholderService {
    constructor() {}

     // emits the number of placeholders to insert
    private placeholderCount$ = new BehaviorSubject<number>(0);

    /** Call this when you’ve kicked off a new upload of N files */
    public setPlaceholderCount(n: number) {
        this.placeholderCount$.next(n);
    }

    /** Subscribe to know “when to insert placeholders” */
    public onNewPlaceholders(): Observable<number> {
        return this.placeholderCount$.asObservable();
    }

    getDataRowPlaceholder$(): Observable<{}> {
        return of({});
    }
}
